import { actionTypes } from './index';


// eslint-disable-next-line import/prefer-default-export
export const changeUrl = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_URL,
    payload: data,
  });
};



// WEBPACK FOOTER //
// ./actions/url.js